module.exports = "<svg viewBox=\"0 0 146.1 146.1\"><path fill=\"#1E1E1C\" d=\"M63 29.5l-28-28c-1.9-1.9-5.1-1.9-7.1 0L14.7 14.7l-6.2 6.2c-16.5 16.5-9.9 50 28.4 88.3s71.7 45 88.2 28.5l6.2-6.2 13.2-13.2c1.9-1.9 1.9-5.1 0-7.1l-28-28c-1.9-1.9-5.1-1.9-7.1 0L93.8 98.8s-12.2 3.1-30.9-15.6-15.6-30.9-15.6-30.9L63 36.6c2-2 2-5.2 0-7.1z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/phone.svg
// module id = 240
// module chunks = 1